var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M10.5,21a10.5,10.5,0,1,1,0-21,10.4,10.4,0,0,1,6.527,2.274A10.543,10.543,0,0,1,20.7,7.992a.7.7,0,1,1-1.363.335A9.1,9.1,0,1,0,19.6,10.5a.7.7,0,1,1,1.4,0A10.511,10.511,0,0,1,10.5,21Zm0-3A1.5,1.5,0,1,1,12,16.5,1.5,1.5,0,0,1,10.5,18ZM10,14a1.223,1.223,0,0,1-.712-.214A.632.632,0,0,1,9,13.274V3.731a.631.631,0,0,1,.282-.513A1.21,1.21,0,0,1,9.99,3H10a1.235,1.235,0,0,1,.712.212A.632.632,0,0,1,11,3.731v9.544a.63.63,0,0,1-.288.512A1.223,1.223,0,0,1,10,14Z",
    transform: "translate(0)",
    fill: "#eb742e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ed9a4f8aed0879de0a98639b7c4ffc4c.svg";
export { ForwardRef as ReactComponent };